import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommentModel } from '@fi-shared/models/comment.model';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

function mediaFileReferenceParser(checkpointAnswer) {
    if (
        checkpointAnswer &&
        checkpointAnswer.MediaBankFileReferences &&
        checkpointAnswer.MediaBankFileReferences.length > 0
    ) {
        return checkpointAnswer.MediaBankFileReferences[0];
    }
}

function commentParser(checkpointAnswer) {
    if (checkpointAnswer && checkpointAnswer.Comments && checkpointAnswer.Comments.length > 0) {
        return checkpointAnswer.Comments[0];
    }
}

function checkpointAnswerParser(checkpointAnswer) {
    if (checkpointAnswer) {
        return checkpointAnswer.Answer;
    }
}

@Component({
    selector: 'fi-checklist-checkpoint-menu',
    templateUrl: './checkpoint-menu.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkpoint-menu.component.scss'],
    standalone: false,
})
export class FiChecklistCheckpointMenuComponent {
    @Input() checklist;
    @Input() checklistViewer;
    @Input() checkpoint;
    @Input() checkpointAnswer;
    @Input() disabled: boolean = false;

    @Output() setDirty = new EventEmitter();
    @Output() removeComment = new EventEmitter();
    @Output() notApplicationToggle = new EventEmitter();
    @Output() answerCleared = new EventEmitter();

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private userDataService: FiUserDataService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    emitSetDirty() {
        this.setDirty.emit();
    }

    // note: not used
    isShowAddPhoto() {
        return !mediaFileReferenceParser(this.checkpointAnswer);
    }

    isShowReplacePhoto() {
        return mediaFileReferenceParser(this.checkpointAnswer);
    }

    // note: not used
    isShowRemovePhoto() {
        return mediaFileReferenceParser(this.checkpointAnswer);
    }

    isShowAddComment() {
        const comment = commentParser(this.checkpointAnswer);
        return !comment || comment.Content.length === 0;
    }

    isShowRemoveComment() {
        const comment = commentParser(this.checkpointAnswer);
        return comment && comment.Content.length > 0;
    }

    isAnswersDisabled() {
        return (
            !this.checklistViewer ||
            !this.checklistViewer.IsActive ||
            this.checklist.IsSetNotApplicable ||
            this.isNotApplicable()
        );
    }

    isAddPhotoDisabled() {
        return this.isAnswersDisabled() || !checkpointAnswerParser(this.checkpointAnswer);
    }

    isClearCheckpointDisabled() {
        return this.isAnswersDisabled();
    }

    isShowNotApplicableCheckpoint() {
        return this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistLocal,
            AccessRightType.Share,
        );
    }

    removeCommentClick() {
        this.removeComment.emit();
    }

    setNotApplicableCheckpoint() {
        if (!this.checkpoint.CheckPointSetting) {
            this.checkpoint.CheckPointSetting = {};
        }
        this.checkpoint.CheckPointSetting.IsSetNotApplicable = !this.checkpoint.CheckPointSetting.IsSetNotApplicable;
        this.notApplicationToggle.emit();
    }

    clearCheckpoint() {
        if (this.checkpointAnswer) {
            const answer = this.checkpointAnswer;
            answer.Answer = null;
            // clear comments
            answer.Comments.length = 0;
            const newComment = new CommentModel(this.fiFormatDateService);
            newComment.ContentLanguageId = this.userDataService.userData.PreferredContentLanguage;
            answer.Comments.push(newComment);
            // clear attachments
            answer.MediaBankFileReferences.length = 0;
            this.answerCleared.emit();
            this.emitSetDirty();
        }
    }

    isNotApplicable() {
        return this.checkpoint.CheckPointSetting && this.checkpoint.CheckPointSetting.IsSetNotApplicable;
    }
}
